import { ApiResponse, TicketManagerQueue } from '@vision/ui/interfaces';
import { TicketManagerApi } from '../ticket-manager.api';
import {
  TicketManagerQueueCreateArgs,
  TicketManagerQueueDeleteArgs,
  TicketManagerQueueUpdateArgs,
  TicketManagerProjectQueuesArgs,
} from './queues.api.types';
import { normalizeTicketManagerQueueResponse, normalizeTicketManagerQueuesResponse } from './queues.mappers';
import {
  buildCreateQueueRequest,
  buildDeleteQueueRequest,
  buildGetProjectQueuesRequest,
  buildUpdateQueueRequest,
} from './queues.routes';

export const QueueEndpoints = TicketManagerApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteTicketManagerQueue: builder.mutation<void, TicketManagerQueueDeleteArgs>({
      query: (args) => ({
        ...buildDeleteQueueRequest(args),
        extraOptions: {
          notification: { autoHandleError: false, autoHandleSuccess: false },
        },
      }),
      invalidatesTags: (_result, error, { projectId }) =>
        error
          ? []
          : [
              { type: 'TicketManagerProjectQueues', id: projectId },
              { type: 'TicketManagerProjectList', id: 'LIST' },
            ],
    }),

    ticketManagerProjectQueues: builder.query<ApiResponse<TicketManagerQueue[]>, TicketManagerProjectQueuesArgs>({
      query: ({ projectId }) => buildGetProjectQueuesRequest({ projectId }),
      transformResponse: normalizeTicketManagerQueuesResponse,
      providesTags: (_result, _error, { projectId }) => [{ type: 'TicketManagerProjectQueues', id: projectId }],
    }),

    createTicketManagerQueue: builder.mutation<ApiResponse<TicketManagerQueue>, TicketManagerQueueCreateArgs>({
      query: ({ name, ordering, projectId }) => buildCreateQueueRequest({ name, ordering, projectId }),
      transformResponse: normalizeTicketManagerQueueResponse,
      invalidatesTags: (_result, _error, { projectId }) => [{ type: 'TicketManagerProjectQueues', id: projectId }],
    }),

    updateTicketManagerQueue: builder.mutation<ApiResponse<TicketManagerQueue>, TicketManagerQueueUpdateArgs>({
      query: ({ name, ordering, projectId, queueId }) =>
        buildUpdateQueueRequest({ name, ordering, projectId, queueId }),
      transformResponse: normalizeTicketManagerQueueResponse,
      invalidatesTags: (_result, _error, { projectId }) => [{ type: 'TicketManagerProjectQueues', id: projectId }],
    }),
  }),
});

export const {
  useDeleteTicketManagerQueueMutation,
  useTicketManagerProjectQueuesQuery,
  useLazyTicketManagerProjectQueuesQuery,
  useCreateTicketManagerQueueMutation,
  useUpdateTicketManagerQueueMutation,
} = QueueEndpoints;
